import { render, staticRenderFns } from "./DescriptionCell.vue?vue&type=template&id=51c26aa6&scoped=true&"
import script from "./DescriptionCell.vue?vue&type=script&lang=js&"
export * from "./DescriptionCell.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCell.vue?vue&type=style&index=0&id=51c26aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c26aa6",
  null
  
)

export default component.exports